const navigation = {
    items: [{
        title: true,
        name: 'Меню'
    }, {
        name: 'Сводка',
        url: {
            name: 'Dashboard'
        },
        icon: 'fa fa-cubes'
    }, {
        name: 'Профиль',
        url: {
            name: 'Profile'
        },
        icon: 'fa fa-user'
    }, {
        name: 'Финансы',
        url: {
            name: 'Finance'
        },
        icon: 'fa fa-money',
        children: [{
            name: 'Счета',
            url: {
                name: 'FinanceAccounts'
            },
            icon: ''
        }, {
            name: 'История',
            url: {
                name: 'FinanceHistory'
            },
            icon: ''
        }]
    }, {
        title: true,
        name: 'Займы'
    }, {
        name: 'Депозиты',
        url: {
            name: 'Deposits'
        },
        icon: 'fa fa-shopping-bag'
    }, {
        name: 'Кредиты',
        url: {
            name: 'Credits'
        },
        icon: 'fa fa-percent'
    }, {
        title: true,
        name: 'Дополнительно'
    }, {
        name: 'Сотрудникам',
        url: {
            name: 'Franchising'
        },
        icon: 'fa fa-users',
        badge: {
            variant: 'primary',
            text: '!'
        },
        franchisee: true,
        children: [{
            name: 'Франшизы',
            url: {
                name: 'FranchisingFranchisee'
            },
            icon: 'fa fa-users2'
        }, {
            name: 'Маркетинг',
            url: {
                name: 'FranchisingMarketing'
            },
            icon: 'fa fa-users2'
        }]
    }, {
        divider: true
    }, {
        name: 'Админка',
        url: {
            name: 'Admin'
        },
        icon: 'fa fa-admin',
        admin: true,
        children: [{
            name: 'Сводка',
            url: {
                name: 'AdminDashboard'
            },
            icon: ''
        }, {
            name: 'Заказы',
            url: {
                name: 'AdminOrders'
            },
            icon: ''
        }]
    }, {
        divider: true
    }, {
        name: 'Выход',
        url: {
            name: 'AuthLogout'
        },
        icon: 'fa fa-sign-out'
    }]
}

export default navigation



// WEBPACK FOOTER //
// ./src/navigation.js